import useApolloClient from '../hooks/useApolloClient';
import { Route, Switch } from 'react-router-dom';
import Assemblies from '../pages/assemblies/Assemblies';
import Customers from '../pages/customers/Customers';
import Users from '../pages/users/Users';
import Testers from '../pages/testers/Testers';
import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { ModeProvider } from '../hooks/useMode';
import TestReports from './waterSupplier/pages/testReports/TestReports';
import WaterServices from './waterSupplier/pages/waterServices/WaterServices';
import NoticesEditor from '../pages/notices/NoticesEditor';
import Notices from '../pages/notices/Notices';
import Dashboard from './waterSupplier/pages/dashboard/Dashboard';
import WaterSites from './waterSupplier/pages/waterSites/WaterSites';
import Jobs from '../pages/jobs/Jobs';
import HazardSurveys from './waterSupplier/pages/hazardSurveys/HazardSurveys';
import HazardSurveyEditor from './waterSupplier/pages/hazardSurveys/HazardSurveyEditor';
import CompanyProfile from './company/pages/profile/CompanyProfile';
import WaterHazards from './waterSupplier/pages/waterHazards/WaterHazards';
import SurveyTemplates from './waterSupplier/pages/surveyTemplates/SurveyTemplates';
import SurveyTemplateDetail from './waterSupplier/pages/surveyTemplates/SurveyTemplateDetail';

const WaterSupplier = () => {
  return (
    <ApolloProvider client={useApolloClient('water-supplier')}>
      <ModeProvider value="water-supplier">
        <Switch>
          <Route
            path={[
              '/water-supplier/test-reports/:id',
              '/water-supplier/test-reports',
            ]}
            component={TestReports}
          />
          <Route
            path={['/water-supplier/jobs/:id', '/water-supplier/jobs']}
            component={Jobs}
          />
          <Route
            path={[
              '/water-supplier/hazard-surveys/new',
              '/water-supplier/hazard-surveys/:id/edit',
            ]}
            component={HazardSurveyEditor}
          />
          <Route
            path={[
              '/water-supplier/hazard-surveys/:id',
              '/water-supplier/hazard-surveys',
            ]}
            component={HazardSurveys}
          />
          <Route
            path={[
              '/water-supplier/assemblies/:id',
              '/water-supplier/assemblies',
            ]}
            component={Assemblies}
          />
          <Route
            path={[
              '/water-supplier/water-services/:id',
              '/water-supplier/water-services',
            ]}
            component={WaterServices}
          />
          <Route
            path={[
              '/water-supplier/water-sites/:id',
              '/water-supplier/water-sites',
            ]}
            component={WaterSites}
          />
          {/*<Route*/}
          {/*  path={[*/}
          {/*    '/water-supplier/water-hazards/:id',*/}
          {/*    '/water-supplier/water-hazards',*/}
          {/*  ]}*/}
          {/*  component={WaterHazards}*/}
          {/*/>*/}
          {/*<Route*/}
          {/*  path="/water-supplier/survey-templates/:id"*/}
          {/*  component={SurveyTemplateDetail}*/}
          {/*/>*/}
          {/*<Route*/}
          {/*  path="/water-supplier/survey-templates"*/}
          {/*  component={SurveyTemplates}*/}
          {/*/>*/}
          <Route
            path={[
              '/water-supplier/customers/:id',
              '/water-supplier/customers',
            ]}
            component={Customers}
          />
          <Route path="/water-supplier/notices/:id" component={NoticesEditor} />
          <Route path="/water-supplier/notices" component={Notices} />
          <Route
            path={['/water-supplier/users/:id', '/water-supplier/users']}
            component={Users}
          />
          <Route
            path={['/water-supplier/testers/:id', '/water-supplier/testers']}
            component={Testers}
          />
          <Route path="/water-supplier/profile" component={CompanyProfile} />
          <Route path="/water-supplier" component={Dashboard} />
        </Switch>
      </ModeProvider>
    </ApolloProvider>
  );
};

export default WaterSupplier;
